<template>
	<div class='custom-fade-in'>
		<div v-if="$route.name === 'job-evaluation-new'">
			<div class="wrapper-big-process">
				<div class="wrapper-process">
					<h3 class="title-process"
						:style="`color:${$appColors.secondary}`"
					>PROCESO DE VALORACION DE PUESTOS</h3>
					<div class="wrapper-list">
						<process-option
							v-for="(process, index) in stages"
							:key="index"
							:process='process'
							:index='index'
							:enabled='process.enabled'
						/>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>
	</div>
</template>
<script>
import processOption from '@/modules/job-evaluation/components/process-option/process-option';
import { mapState } from 'vuex';
import { pathOr, pipe, map, prop, applySpec } from 'ramda';

export default {
	name: 'page-job-evaluation-new',
	components: {
		processOption,
	},
	beforeMount() {
		this.$store.dispatch('jobEvaluation/loadJobEvaluationConfig');
		this.$store.dispatch('jobEvaluation/getGuidelineModelStatus');
		this.$store.dispatch('jobEvaluation/loadRoles');
		this.$store.dispatch('jobEvaluation/loadTitles');
		this.$store.dispatch('jobEvaluation/loadExperiences');
		this.$store.dispatch('jobEvaluation/loadEnglishLevels');
		this.$store.dispatch('jobEvaluation/loadVerbs');
	},
	computed: {
		...mapState('jobEvaluation', {
			stages: pipe(
				pathOr([], ['mainData', 'config', 'stages']),
				map(
					applySpec({
						name: prop('title'),
						enabled: pipe(prop('stageStatus'), val => !!val),
						description: prop('description'),
						urlImage: prop('urlImage'),
						goTo: prop('goTo'),
					}),
				),
			),
		}),
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-process {
		background: map-get($colors, white);
		border: solid 1px map-get($colors, gray-slider);
		border-radius: 8px;
		padding: 52px 5% 55px;
	}

	.title-process {
		font-size: map-get($sizes, big);
		margin-bottom: 70px;
		text-align: center;
	}

	.wrapper-list {
		display: flex;
		justify-content: space-between;
	}

	.list-process {
		display: flex;
		flex: 1 1 30%;
		padding: 10px;
	}

	.process-image {
		flex: 1 1 90%;
	}

	.process-arrow {
		flex: 1 1 10%;
	}

	.wrapper-big-process {
		align-items: center;
		display: flex;
		flex-direction: column;
		height: calc(100vh - 110px);
    justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/page-job-evaluation-new.vue